import { HOST } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from "./CompanyInfo.API";

const PERSIST_STORE_ITEM = {
}

class Store {
  constructor() {

  }

  find = async (data) => {
    let res = await api.find(data);
    let json = await res.json();
    return json;
  }
  
}

export default new Store();


// WEBPACK FOOTER //
// ./src/services/companyInfo/CompanyInfo.Store.js